import { render, staticRenderFns } from "./OneCoupon.vue?vue&type=template&id=6bf8fc9e&"
import script from "./OneCoupon.vue?vue&type=script&lang=js&"
export * from "./OneCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports